import React, { useRef, useState } from 'react';
import classnames from 'classnames';

import { FlexRow } from 'ui-components/components/flex';

import styles from './styles.module.less';
import { useOnElementResize } from '../../../hooks/use-on-element-resize';

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const ResponsiveLayout = ({ className = '', children }) => {
  const containerRef = useRef();
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  // Css cannot determine the scrollbar width, so we need to calculate it in JS
  useOnElementResize(containerRef, () => {
    setScrollbarWidth(containerRef.current.offsetWidth - containerRef.current.scrollWidth);
  });

  return (
    <div ref={containerRef} className={classnames(styles.container, className)}>
      <FlexRow className={classnames(styles.grid)} style={{ '--layout--scrollbar-width': `${scrollbarWidth}px` }}>
        {children}
      </FlexRow>
    </div>
  );
};
